module.exports = __webpack_public_path__ + "static/media/less-than.86d047dc.svg";